export default __webpack_public_path__ + "static/media/american-century-investments-logo.78cb57eb.svg";